export class ReportParameter {
    index: number;
    label: string;
    key: any;
    value: string;

    constructor(index: number, label: string, key: any, value: string) {
        this.index = index;
        this.label = label;
        this.key = key;
        this.value = value;
    }
}